  document.addEventListener("DOMContentLoaded", (event) => {
    const tabs = document.querySelectorAll('.c-tab');
    
    tabs.forEach(tab => {
      const buttons = tab.querySelectorAll('.c-tab__links button');
      const tabContents = tab.querySelectorAll('.c-tab__content');

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const tabId = button.getAttribute('data-tab');
          console.log(tabId);

          // clear previous result
          tabContents.forEach(tabContent => tabContent.style.display = 'none');
          buttons.forEach(button => button.classList.remove('is-active'));

          // display new tab
          button.classList.add('is-active');
          tab.querySelector(`#${tabId}`).style.display = 'block';
        })
      })

      // init
      setTimeout(() => {
        tabContents.forEach(tabContent => tabContent.style.display = 'none');
        buttons[0].click();
      }, 1); // fix pagination problem
    })
  });